import { gql } from '@apollo/client';
import { DBH_UNITS } from '../../constants/units';
import { MULTI_YEAR, N_YEARS } from '../../constants/years';
import { useUnits } from '../../contexts/UnitContext';
import { asDecimal } from '../../utils/formatters';
import ExportDashboardYearOrYearsButton from './ExportDashboardYearOrYearsButton';
import { metricsQueryString } from '../../utils/utils';
import carbonMetrics from '../../constants/carbonMetrics';
import { getCarbonData } from '../../utils/transforms';

const carbonQuery = gql`
  query ProjectListCarbonQuery($ids: [ID!]) {
    farms(ids: $ids) {
      id
      name
      startYear
      cropAggregates {
        crop {
          id
          name
          carbon {
            ${metricsQueryString(carbonMetrics)}
          }
        }
        ecologicalSummary {
          carbonTonsByYear
        }
      }
    }
  }
`;

const carbonColumns = (year, years, startYear) => [
  { displayString: 'Farm Name', accessor: 'farmName' },
  { displayString: 'Crop', accessor: (row) => row?.crop?.name },
  ...carbonMetrics,
  {
    displayString: `Cumulative Tons CO2 by ${
      year === MULTI_YEAR ? startYear + years - 1 : year
    }`,
    accessor: 'carbonTonsByYear',
    format: (carbonTonsByYear, { endYearIndex }) => {
      if (endYearIndex < 0) return asDecimal(0);
      // cumulative carbon should be for either the year we're looking at
      // or the last year we have data for
      return asDecimal(carbonTonsByYear[Math.min(N_YEARS - 1, endYearIndex)]);
    },
  },
];

const carbonDataTransform = (dbhUnits) => (farmData) =>
  getCarbonData(dbhUnits)(farmData).cropAggregates;

const ExportDashboardCarbonButton = ({ year, years, startYear, ...props }) => {
  const dbhUnits = useUnits(DBH_UNITS);

  return (
    <ExportDashboardYearOrYearsButton
      columns={carbonColumns(year, years, startYear)}
      dataTransform={carbonDataTransform(dbhUnits)}
      query={carbonQuery}
      name="carbon"
      year={year}
      years={years}
      startYear={startYear}
      {...props}
    />
  );
};

export default ExportDashboardCarbonButton;
